<template>
    <div>
        <div class="s_1280">
            <nav class="navbar wrapper navbar-expand-md fixed-top">
                <div class="col-4">
                    <router-link to="/home">
                        <img class="logo-img" id="logo-btn" src="images/logo.png" />
                    </router-link>
                </div>
                <div class="col-8">
                    <div class="app navigation">
                        <a class="apply-btn" href="/#/newvisa">Apply Now</a>
                        <TopMenu></TopMenu>
                    </div>
                </div>
            </nav>
            <div class="main app">
                <div class="container-fluid wrapper">
                    <div class="row reg-box full-width-reading">
                        <div class="col-3">
                            <div class="left-bg">
                                <div class="left-links">
                                    <ul>
                                        <li><a href="#/covid">COVID - 19 Protocols</a></li>
                                        <li><a href="#/visaprocess">Visa Process</a></li>
                                        <li><a href="#/appterms">Visa Application Terms</a></li>
                                        <li><a href="#/needvisa">Do I Need a Visa</a></li>
                                        <li><a class="active" href="#/req_photo">Photo Requirements</a></li>
                                        <li><a href="#/req_passport">Passport Requirements</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-1">

                        </div>
                        <div class="col-8">
                            <div class="document top98 photoreq">
                                <h2>Photo Requirements</h2>
                                <img class="img-fluid img-thumbnail top32" src="/images/photo.png" />
                                <ul class="top32">
                                    <li>
                                        The image should be in color and 28mm by 36mm
                                    </li>
                                    <li>The size of the photo must be less or equal to 30 kilobytes (kB)</li>
                                    <li>The image should be in JPG format</li>
                                    <li>The image must have adequate brightness and contrast</li>
                                </ul>
                                <ul>
                                    <li>The skin tone should be natural</li>
                                    <li>Either too dark or too light, photo will not be acceptable</li>
                                    <li>It should show a close up of the head and (partial) shoulders</li>
                                    <li>The image should be straight looking, centered with neutral expression</li>
                                </ul>
                                <ul>
                                    <li>Face should be in sharp focus and clear with no ink marks/creases/lines</li>
                                    <li>The face (from forehead edge to bottom of chin) should be 70 to 80% of the photo</li>
                                    <li>The eyes must be open and no hair obscuring the face</li>
                                </ul>
                                <ul>
                                    <li>Prescription glasses if worn should be clear and thin framed and should not have flash reflection or obscure the eyes </li>
                                    <li>Head coverings, hair, head-dress or facial ornaments should not obscure the face </li>
                                    <li>The photo must have plain light background</li>
                                    <li>There must be no other people or object in the photo</li>
                                    <li>The lighting must be uniform with no shadows on the face or behind </li>
                                    <li>Red eye photos are not allowed</li>
                                </ul>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="bg white s_768">
            <div class="d-flex flex-column flex-md-row align-items-center mb-3 bg-white">
                <div class="container-fluid wrapper index">
                    <div class="nav-top row">
                        <div class="col-4">
                            <router-link to="/home">
                                <img class="logo-img" id="logo-btn" src="images/logo.png" />
                            </router-link>
                        </div>
                        <div class="col-8">
                            <div class="navigation">
                                <TopMenu :ShowContinueSubmission=true></TopMenu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 top64">
                    <div class="left-links hrz-menu">
                        <ul>
                            <li><a href="#/covid">COVID - 19 Protocols</a></li>
                            <li><a href="#/visaprocess">Visa Process</a></li>
                            <li><a href="#/appterms">Visa Application Terms</a></li>
                            <li><a href="#/needvisa">Do I Need a Visa</a></li>
                            <li><a class="active" href="#/req_photo">Photo Requirements</a></li>
                            <li><a href="#/req_passport">Passport Requirements</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 top16">
                    <div class="document photoreq">
                        <h2>Photo Requirements</h2>
                        <img class="img-fluid img-thumbnail top32" src="/images/photo.png" />
                        <ul class="top32">
                            <li>
                                The image should be in color and 28mm by 36mm
                            </li>
                            <li>The size of the photo must be less or equal to 30 kilobytes (kB)</li>
                            <li>The image should be in JPG format</li>
                            <li>The image must have adequate brightness and contrast</li>
                        </ul>
                        <ul>
                            <li>The skin tone should be natural</li>
                            <li>Either too dark or too light, photo will not be acceptable</li>
                            <li>It should show a close up of the head and (partial) shoulders</li>
                            <li>The image should be straight looking, centered with neutral expression</li>
                        </ul>
                        <ul>
                            <li>Face should be in sharp focus and clear with no ink marks/creases/lines</li>
                            <li>The face (from forehead edge to bottom of chin) should be 70 to 80% of the photo</li>
                            <li>The eyes must be open and no hair obscuring the face</li>
                        </ul>
                        <ul>
                            <li>Prescription glasses if worn should be clear and thin framed and should not have flash reflection or obscure the eyes </li>
                            <li>Head coverings, hair, head-dress or facial ornaments should not obscure the face </li>
                            <li>The photo must have plain light background</li>
                            <li>There must be no other people or object in the photo</li>
                            <li>The lighting must be uniform with no shadows on the face or behind </li>
                            <li>Red eye photos are not allowed</li>
                        </ul>
                    </div>
                </div>


            </div>
            <div class="row">
                <div class="col-12">
                    <div class="placeholder top16">
                        <img src="/images/auth-bird-768.jpg" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

    import TopMenu from "./Menu";
    export default {
        components: { TopMenu },
        name: 'ReqPhoto',

        model: {},
        data: () => ({

        }),
        mounted() {
           

        },
        computed: {

        },
        methods: {
        }
    }
</script>
